export const paymentModes = (state) => state.paymentModes
